// generated by genversion
export var version = '4.5.6';
//# sourceMappingURL=version.js.map